import { inject, Injectable } from '@angular/core';
import { environmentDev } from '../../../environments/environment.dev';
import { IField } from '../model/i-field';
import { ICard, ICardResponse, ICardVariant } from '../model/i-card';
import { HttpClient } from '@angular/common/http';
import { BackendService } from '../../core/services/backend/backend.service';
import { FieldBuilder } from './fields/field-builder';
import { tap } from 'rxjs';
import * as _ from "lodash";
import { RdGameService } from './games/rd-game';
import { Newbie } from './newbies/newbie';
import { AllStatus } from '../../core/services/status/all-status';
import { NotificationService } from '../../core/services/Notification/notification';
import { GameMode } from '../model/i-game-mode';

@Injectable({
  providedIn: 'root'
})
export class WorkCardService {

  cardsAll: any[] = environmentDev.cards;
  fields: Array<any> = environmentDev.fields;
  newBie: boolean;
  showCard: any;
  nowField: IField;
  http = inject(HttpClient);
  backend = inject(BackendService);
  fieldBuilder = inject(FieldBuilder);
  rdUse = inject(RdGameService);
  newbie = inject(Newbie);
  allStatus$ = inject(AllStatus);
  notification = inject(NotificationService);

  initial(position: number, player_id: number, uuid: string, isNewbie: boolean, turnId: number = 0, gameMode: GameMode = 'single'){
    this.newBie = isNewbie;
    this.nowField = this.fieldBuilder.findField(position);    
    this.findCard(position, this.nowField?.type_id, uuid, player_id, turnId, gameMode);
    //this.showCard = structuredClone(this.findCard(this.nowField?.type_id));
  }

  private findField(position: number): IField{
    return this.fields.find((field: IField)=> position === field.position ) as IField;
  }

  private findCard(position: number,type: number, uuid: string, player_id: number, turnId: number, gameMode: GameMode){
    this.http.post<ICardResponse>(`${this.backend.getApiUrl()}/rooms/${uuid}/turn-info/${player_id}`, {
      "dice_value": 2,
      "position": position,
      "type_id": type,
      "group_id": 0
    }).pipe(
      tap((result) => this.cardAll(result.card, player_id, turnId, gameMode))
    ).subscribe({
      error: (error: any) => console.error(`Failed to load card for room ${uuid}`, error),
    });
    //return this.cardsAll.find((card: any)=> card.type_id === type );
  }

  getCard(cardId: number){
    return this.http.get<ICardResponse>(`${this.backend.getApiUrl()}/cards/${cardId}`);
  }

  cardAll(card: ICard, ownerPlayerId: number, turnId: number, gameMode: GameMode = 'single'){
    if(this.newBie){
      let cardNewbie = this.newbie.cardForNewBie(structuredClone(card));
      if(cardNewbie.data?.variants){
        cardNewbie.data.variants = this.shuffleVariants(cardNewbie);
      }
      this.saveCardForTurn(cardNewbie, ownerPlayerId, turnId, gameMode);
    }else{
      let cardNewbie = structuredClone(card);
      if(cardNewbie.data?.variants){
        cardNewbie.data.variants = this.shuffleVariants(cardNewbie);
      }
      this.saveCardForTurn(cardNewbie, ownerPlayerId, turnId, gameMode);
    }
  }

  shuffleVariants(card: ICard): ICardVariant[] | undefined{
    return _.shuffle(card.data?.variants);
  }

  hasEmTag(card: ICard): boolean{
    const text = card.data?.human_descrition?.text;
    return typeof text === 'string' && /<em(?=[\s>])[^>]*>/i.test(text);
  }

  private saveCardForTurn(card: ICard, ownerPlayerId: number, turnId: number, gameMode: GameMode): void{
    void this.rdUse.saveCard(card, ownerPlayerId, turnId).then((committed) =>{
      if(!committed){
        return;
      }
      if(this.hasEmTag(card)){
        this.notification.showAiExplanation(gameMode);
      }
      if(!this.allStatus$.activeLevel.includes(card.level)){
        this.allStatus$.activeLevel.push(card.level);
      }
      this.allStatus$.setViewBlockDice(false);
      this.allStatus$.isGoToFinish.set(true);
    }).catch((error: unknown) =>{
      console.error(`Failed to save card ${card.card_id} for turn ${turnId}`, error);
    });
  }

  searchCard(type: number){
    // this.showCard = structuredClone(this.findCard(type));
  }
  
}
